import AbstractComponent from './AbstractComponent';
import { createCookie, readCookie } from 'helpers/Cookies';

class Cookies extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.destroy = this.destroy.bind(this);
    this.handleClickClose = this.handleClickClose.bind(this);
  }

  initialize() {
    const cookie = readCookie('seen-cookie-message');

    if (cookie !== null || cookie === 'yes') {
      this.destroy();
    } else {
      this.ui.$element.classList.add('is-open');
    }
  }

  getUI() {
    const ui = super.getUI();
    ui.$close = ui.$element.querySelector('.cookies__close');
    return ui;
  }

  destroy() {
    this.events(false);
    this.ui.$element.remove();
  }

  events(listen) {
    super.events(listen);
    const listener = listen ? 'addEventListener' : 'removeEventListener';
    const { $close } = this.ui;
    $close[listener]('click', this.handleClickClose);
  }

  handleClickClose(event) {
    createCookie('seen-cookie-message', 'yes', 7, '/');
    this.destroy();
  }
}

export default Cookies;
